module.exports = __webpack_public_path__ + "static/media/month_08.96196ee7.png";